import { StackNavigationProp } from '@react-navigation/stack';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { DrawerNavigationProp } from '@react-navigation/drawer';

//Module files
import { CustomerListData } from '../../components/customers/customerListModule';
import { TaxData } from '../../components/tax/taxModule';
import { CategoryFormValues } from '../../components/category/categoryModule';

interface CommonNavigationParams { screen: string, params: { isWrite: boolean, isRead: boolean } }

// Define the type for your drawer screens
export type DrawerScreens = {
    "SellScreenStack": CommonNavigationParams
    "ProductStack": { screen: string } | undefined
    "CategoryList": undefined
    "BrandStack": undefined
    "OptionStack": undefined
    "ModifierScreen": undefined
    "CustomerStack": undefined
    "CustomerGroupStack": undefined
    "StaffStack": undefined
    "InvitedStaff": undefined
    "RoleStack": undefined
    "CategoryStack": undefined
    "ManualDiscountStack": CommonNavigationParams
    "AutomaticDiscountStack": CommonNavigationParams
    "BuyXgetYDiscountStack": CommonNavigationParams
    "PayXGetFreeStack": CommonNavigationParams
    "TaxStack": undefined
    "GiftStack": CommonNavigationParams
    "PurchaseGiftCardStack": { screen: string } | undefined
    "IssueGiftStack": CommonNavigationParams
    "SettingStack": undefined | { screen: string }
    "ProfileStack": undefined,
    "OrdersStack": undefined | { screen: string, params: { customerId: number } }
    "DashboardStack": undefined
    "InventoryStack": undefined
    "ImageGalleryStack": { isReadOnly: boolean },
    "ZoneStack": undefined
}

type CategoryProducts = { categoryId: number, isView: boolean, isAllProduct: boolean, formikValues: CategoryFormValues, productCount?: number }
type TaxProducts = { taxId: number, isView: boolean, isAllProduct: boolean, formikValues: any, productCount?: number }

// Define the type for your StackScreens
export type StackScreens = {
    "BuyXgetYDiscount": undefined
    "PayXGetFree": undefined
    "ManualDiscount": undefined
    "AutomaticDiscount": undefined
    "GiftCardList": undefined
    "AddEditGiftCard": { giftCardId: number }
    "RestoreOrderList": { isRestore: boolean }
    "OrderList": { customerId: number, isPos: boolean };
    "IssueGiftCard": undefined
    "AllProductList": { isAll?: boolean, id?: number, formikValues?: any }
    "AddEditCustomer": { customerId?: number, isSellScreen?: boolean, routeName: "Active Customer" | "IssueGiftCard" | "InActive Customer" | "SellScreen" | "ViewCustomerDetails", isUserVerified?: boolean, userId?: number, screen?: string }
    "AddEditBrand": { id?: number }
    "Modifiers": { key: "set" | "options" }
    "StaffLoginHistory": { staffId?: number }
    "Active Customer": { isRefresh: boolean, isActiveCustomer: true }
    "InActive Customer": { isRefresh: boolean, isActiveCustomer: false }
    "PrintCustomer": { customerHistoryData: CustomerListData }
    "CustomerHistory": { customerHistoryData: CustomerListData }
    "ProductDetails": { productId: number }
    "PrintMembershipCard": { customerId: number }
    "ProductsTap": { isRefresh: boolean }
    "SellScreen": undefined
    "NewSellScreen": undefined
    "AddEditTax": ({ ele: TaxData } | undefined) | ({ screen: "Products" } & TaxProducts)
    "AddEditCustomerGroups": { isAdd?: boolean, isEdit?: boolean, id?: number, customerCount?: number, isView?: boolean }
    "AddEditVendor": { id: number, isActive: boolean } | undefined
    "ViewHistory": { id: number }
    "AddEditLocation": { editId?: number, locationArrLength: number, defaultLen?: number } | undefined
    "AddEditManual": { discountId: number } | undefined
    "AddEditPayXGetFree": { discountId: number } | undefined
    "AddEditAutomaticDiscount": { id: number } | undefined
    "ViewDiscount": { id: number, routeName: 'Automatic' | 'BuyXgetY' | 'Manual' | 'PayXGetFree' }
    "AddEditBuyXgetYDiscount": { id: number } | undefined
    "ChangePin": { token: string },
    "AddEditProduct": { productId: number } | undefined
    "BulkEdit": undefined,
    "CreatePayment": { isEdit: true, paymentId: number } | { isEdit: false }
    "PaymentList": { isRefresh: boolean } | undefined,
    "CreateBill": { isEdit: boolean, billId: number } | undefined,
    "AddEditVendorCredit": { isEdit: true, creditId: number } | { isEdit: false }
    "CustomEmailNotificationDetails": undefined
    "Contact Information": undefined
    "SellScreenSummary": undefined
    "LoginPin": undefined
    "CashRegister": { isRegisterOpen: boolean, isCashRegisterDataEmpty: boolean, cashRegisterId: number } | undefined
    "SignIn": undefined
    "Register": undefined
    "SignUp": undefined
    "UpdatePin": undefined
    "ForgotPin": undefined
    "ViewCustomerDetails": { customerId: number },
    "AddEditPurchaseReceive": { isEdit?: boolean, id?: number } | undefined,
    "staffList": { isActive: string },
    "AddEditStaff": { isEdit: boolean, id: any, isActive: boolean },
    "TargetHistory": undefined
    "AddEditCds": { id?: number, isActive?: boolean } | undefined
    "ReadymadeProducts": undefined
    "issuedGiftCardReport": { beginDate: string | null, endDate: string | null }
    "TaxReport": { beginDate: string | null, endDate: string | null },
    "RevenueReport": { beginDate: string | null, endDate: string | null },
    "soldProductReport": { beginDate: string | null, endDate: string | null },
    "RegisterClosureReport": { beginDate: string | null, endDate: string | null },
    "ActivityHistory": { id: number },
    "purchasedGiftCardReport": undefined,
    "StaffReport": { beginDate: string, endDate: string },
    "CustomerReport": { beginDate: string, endDate: string },
    "OfferReport": { beginDate: string, endDate: string },
    "PaymentReport": { beginDate: string | null, endDate: string | null },
    "OrderReport": { beginDate: string | null, endDate: string | null },
    "AddEditCategories": { categoryId: number, isView: boolean, productCount?: number } | ({ screen: "Products" } & CategoryProducts)

    "CategoryProducts": CategoryProducts
    "TaxProducts": TaxProducts
    "InventoryAdjustmentHistory": undefined
    "TransactionHistory": { vendorId: number }
    "OrderSummary": undefined
    "Cash Movements": undefined
    "addUpdateZone": undefined | { id: number }
    "ProductSettings": undefined
}

export type AppNavigationParamList = StackScreens & DrawerScreens

export type DrawerNavigationProps<T extends keyof AppNavigationParamList> = DrawerNavigationProp<AppNavigationParamList, T>;

export type StackNavigationProps<T extends keyof AppNavigationParamList> = StackNavigationProp<AppNavigationParamList, T>;

export type NavigationProps<T extends keyof AppNavigationParamList> = DrawerNavigationProps<T> & StackNavigationProps<T>;

type RouteProps<T extends keyof AppNavigationParamList> = RouteProp<AppNavigationParamList, T>;

export const useAppNavigation = <T extends keyof AppNavigationParamList>() => {
    return useNavigation<NavigationProps<T>>();
};

export const useAppRoute = <T extends keyof AppNavigationParamList>(routeKey?: T) => {
    return useRoute<RouteProps<T>>();
};
